import { GzEasmAsnMapReportsWebComponent } from './component/GzEasmAsnMapReportsWebComponent';

export { GzEasmAsnMapReportsWebComponent };
